import React, { useRef, useEffect, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { InputNumber } from 'primereact/inputnumber';

export const TabelaCampanhaMudas = ({ isEditing, listMudas, campanhaMudas, setCampanhaMudas, setListMudas }) => {
    const toast = useRef(null);
    const [campanhasMudas, setCampanhasMudas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const { id } = useParams();
    const [mudas, setMudas] = useState(false);

    useEffect(() => {
        const fetchCampanhaMudas = async () => {
            try {
                await getCampanhaMudas();
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchCampanhaMudas();

    }, [])

    const getCampanhaMudas = async () => {
        setIsLoading(true)
        setCampanhasMudas([])

        try {

            if (isEditing) {
                const response = await api.get(`mudas/${id}`);

                response.data.itens.map(campanhaMuda => {
                    setCampanhasMudas(campanhaMudas => [...campanhaMudas, campanhaMuda])
                })
            }

        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter mudas', detail: error.toString() });
        }

        setIsLoading(false)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">

                <Button
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-rounded p-mr-2 p-button-danger"
                    loading={isDeleting}
                    onClick={() => handleDeleteClick(rowData)}
                />

            </div>
        );
    }

    const codigoBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.muda.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const mudasBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome do Muda</span>
                    <span className="table-data">{rowData.muda.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const quantidadeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Quantidade</span>
                    <span className="table-data">{rowData.quantidade.toLocaleString('pt-BR')}</span>
                </p>
            </React.Fragment>
        );
    }

    const saldoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Saldo</span>
                    <span className="table-data">{rowData.saldo != null ? rowData.saldo.toLocaleString('pt-BR') : 0}</span>
                </p>
            </React.Fragment>
        );
    }

    async function handleGetMudas() {

        await api.get("mudas/mudasAll").then((response) => {
            const mudas = response.data.map(item => {
                return {
                    id: item.id,
                    nome: item.nome
                }
            });

            setMudas(mudas);
        });

    }

    useEffect(async () => {
        await handleGetMudas();

    }, []);

    const handleDeleteClick = (data) => {
    // 1. Identifica o ID do registro (garante compatibilidade caso o ID venha como data.id ou data.campanhaMudaId)
    const itemId = data.id || data.muda.id;

    console.log(data);

    confirmDialog({
        message: `Você tem certeza que quer remover ${data.muda?.nome}?`,
        header: 'Confirmação',
        icon: 'pi pi-exclamation-triangle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: async () => {
            setIsDeleting(true);

            try {
                // 2. Se o registro já existir no banco (possuir ID), executa a requisição DELETE no back-end
                if (itemId) {
                    // Pega o e-mail do usuário autenticado no localStorage ou contexto do React
                    const userEmail = localStorage.getItem('userEmail') || ''; 

                    await api.delete(`/campanhaMudas/${itemId}`, {
                        headers: {
                            'email': userEmail
                        }
                    });
                }

                // 3. Após confirmação de sucesso do banco (HTTP 200/204), atualiza a lista local
                const novaListaCampanhaMudas = campanhaMudas.filter(item => item !== data);
                
                setCampanhaMudas(novaListaCampanhaMudas);

                const tempMudas = novaListaCampanhaMudas.map(item => item.muda);
                setListMudas(
                    mudas.filter((muda) => !tempMudas.some((campanhaMuda) => campanhaMuda.id === muda.id))
                );

                toast.current.show({
                    life: 5000,
                    severity: 'success',
                    summary: 'Remoção concluída!',
                    detail: `Muda ${data.muda?.nome} removida com sucesso`
                });

            } catch (error) {
                console.error("Erro na exclusão:", error);
                const mensagemErro = error.response?.data?.message || error.response?.data || 'Erro ao tentar excluir no banco de dados';
                
                toast.current.show({
                    life: 5000,
                    severity: 'error',
                    summary: 'Erro ao remover a muda',
                    detail: mensagemErro
                });
            } finally {
                setIsDeleting(false);
            }
        }
    });
};

    useEffect(() => {

    }, [campanhaMudas]);

    const onRowEditComplete1 = (e) => {
        let campanhaMudas2 = [...campanhaMudas];
        let { newData, index } = e;

        campanhaMudas2[index] = newData;

        setCampanhaMudas(campanhaMudas2);
    }

    const handleEdit = (data, campo, value) => {
        let minimoQtd = data.quantidade - data.saldo;
        if (value < minimoQtd) {
            toast.current.show({ life: 2000, severity: 'error', summary: `A quantidade não pode ser menor que ${minimoQtd}!` });
        }
        else {
            data[campo] = value;
        }

    }

    const editarQuantidade = (options) => {

        return <InputNumber value={options.rowData.quantidade} onValueChange={((e) => { handleEdit(options.rowData, 'quantidade', e.value) })} mode="decimal" minFractionDigits={2} maxFractionDigits={2} currency="BRL" locale="pt-BR" />

    }

    return (

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable
                        editMode="row"
                        onRowEditComplete={onRowEditComplete1}
                        responsiveLayout="scroll"
                        value={campanhaMudas}
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma muda encontrada"
                        dataKey="id"
                        paginator
                        rows={20}
                        currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} mudas"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[20, 30]}
                        sortField="nome"
                        sortOrder={1}
                        removableSort

                    >

                        <Column style={{ width: '12%' }}
                            field="mudaId"
                            header="Código"
                            sortable
                            body={codigoBodyTemplate}

                        />

                        <Column
                            field="nome"
                            header="Nome da Muda"
                            sortable
                            body={mudasBodyTemplate}

                        />

                        <Column
                            field="quantidade"
                            header="Quantidade"
                            sortable
                            body={quantidadeBodyTemplate}
                            editor={(options) => editarQuantidade(options)}
                            style={{ width: '10%' }}

                        />

                        <Column
                            rowEditor
                            headerStyle={{ width: '10%', minWidth: '8rem' }}
                            bodyStyle={{ textAlign: 'center' }}>
                        </Column>

                        <Column
                            field="saldo"
                            header="Saldo"
                            sortable
                            body={saldoBodyTemplate}
                            style={{ width: '10%' }}
                        />

                        <Column
                            header="Ações"
                            body={actionBodyTemplate}

                        />

                    </DataTable>

                </div>
            </div>
        </div>

    );
}
